// extracted by mini-css-extract-plugin
export default {"resultsContainer":"results_resultsContainer__JPiEZ","textCenter":"results_textCenter__bxHkq","fontBold":"results_fontBold__hgjM+","block":"results_block__laP6D"};